
































































































































import getRandomColor from 'piramis-js-utils/lib/getRandomColor'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import PieChart from '../../Charts/PieChart/PieChart.vue'
import { PieChartDataRecord } from '../../Charts/PieChart/types'
import EmptyData from '../../EmptyData/EmptyData.vue'
import { BotUsersConfig, GetActivityReportResponse } from '../types'

@Component({
  components: {
    PieChart,
    EmptyData
  }
})
export default class UtmStatistics extends Vue {
  @Prop() getUtmReports!: BotUsersConfig['getUtmReports']

  utmReports: Record<string, Partial<GetActivityReportResponse & { color: string }>> | null = null

  utmActivePieData: Array<PieChartDataRecord> = []

  utmDisabledPieData: Array<PieChartDataRecord> = []

  key = 0

  @Emit()
  selectUtm(utmName: string) {
    return utmName
  }

  color() {
    const letters = "0123456789ABCDEF";
    let color   = "#";
    for(let i = 0; i < 6; i++) {
      color += letters[ Math.floor(Math.random() * 16) ];
    }
    return color;
  }

  colors: Array<string> = []

  created() {
    this.getUtmReports()
      .then((data) => {
        this.utmReports = data

        Object.entries(data)
          .forEach(([ name, data ]) => {
            const color = getRandomColor()
            this.colors.push(color)

            this.$set(this.utmReports![name], 'color', color)

            this.utmActivePieData.push({
              name,
              data: data.active ?? 0
            })

            this.utmDisabledPieData.push({
              name,
              data: data.disabled ?? 0
            })

          })

        this.key += 1

      })
  }
}
